import * as React from 'react';

import type { EquipmentCostViewModel } from 'ab-viewModels/equipmentCost.viewModel';
import type { LocationViewModel } from 'ab-viewModels/location/location.viewModel';
import type * as ResourceStatusesViewModel from 'ab-viewModels/resources/resourceStatuses.viewModel';
import type { SkillViewModel } from 'ab-viewModels/skill.viewModel';

import { EquipmentCostCategoryLabel } from '@acceligentllc/shared/enums/equipmentCostCategory';

import StatusLabel from 'af-components/StatusLabel';
import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';

// Equipment Cost

export const getEquipmentCostOptionValue = (option: EquipmentCostViewModel) => `${option.id}`;

export const getEquipmentCostOptionLabel = (option: EquipmentCostViewModel) => {
	const text = `${option.subcategory}`;
	const smallText = `${option.type && EquipmentCostCategoryLabel[option.type]}, ${option.groupName}, ${option.categoryName} `;
	return `${text} ${smallText}`;
};

export const formatEquipmentCostOptionLabel = (option: EquipmentCostViewModel) => {
	const text = `${option.subcategory}`;
	const smallText = `${option.type && EquipmentCostCategoryLabel[option.type]}, ${option.groupName}, ${option.categoryName} `;
	return (
		<div>
			<div>{text}</div>
			<small className="text-grey">{smallText}</small>
		</div>
	);
};

export const getTextForEquipmentCost = (data: EquipmentCostViewModel) => {
	const { subcategory } = data;
	return `${subcategory}`;
};

export const filterEquipmentCosts = (option: { data: EquipmentCostViewModel; }, text: string) => {
	const loweredText = text ? text.toLowerCase() : '';
	const searchableText = getTextForEquipmentCost(option.data);
	return searchableText.toLowerCase().includes(loweredText);
};

// Location

export const getLocationOptionValue = (option: LocationViewModel) => `${option.id}`;

export const getLocationOptionLabel = (option: LocationViewModel) => `${option.nickname} ${option?.address?.street ?? ''}`;

export const formatLocationOptionLabel = (option: LocationViewModel) => {
	return (
		<div>
			<div>{option.nickname}</div>
			<small>{option?.address?.street ?? ''}</small>
		</div>
	);
};

export const getTextForLocation = (data: LocationViewModel) => `${data.nickname}`;

export const filterLocations = (option: { data: LocationViewModel; }, text: string) => {
	const loweredText = text ? text.toLowerCase() : '';
	const searchableText = getTextForLocation(option.data);
	return searchableText.toLowerCase().includes(loweredText);
};

// Skills

export const getSkillOptionValue = (option: SkillViewModel) => `${option.id}`;

export const getSkillOptionLabel = (option: SkillViewModel) => option.name;

// Equipment Status

export const renderResourceStatusMenuItem = ({ available, name }: ResourceStatusesViewModel.Item) => <StatusLabel isAvailable={available} label={name} />;

// Other

const EQUIPMENT_ID_HELP = (
	<div>
		<div>Id must contain two segments separated with <strong>-</strong></div>
		<div>Each segment can have up to 8 alphanumeric characters.</div>
		<div>Valid examples: <strong>JJC-100</strong>, <strong>A-1</strong>, <strong>LONG1234-NAME4321</strong></div>
	</div >
);

export const renderEquipmentIdLabel = () => {
	return (
		<div className={styles['label__with-tooltip']}>
			Equipment ID *
			<Tooltip className="tooltip--center-text" message={EQUIPMENT_ID_HELP}>
				<span className="icon-help_fill" />
			</Tooltip>
		</div>
	);
};
